import { GzSingleSelectComplexWebComponent } from './component/GzSingleSelectComplexWebComponent';

export { GzSingleSelectComplexWebComponent };
